interface Props {
  name: string
  size?: number
  color?: string
}

/** Deterministic-colored initial avatar (2 chars max). */
export function Avatar({ name, size = 36, color }: Props) {
  const initials = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() ?? '')
    .join('')
  const bg = color ?? hashColor(name)
  return (
    <div
      className="inline-flex items-center justify-center rounded-full font-rounded font-semibold"
      style={{
        width: size,
        height: size,
        background: bg,
        color: '#0B0F0E',
        fontSize: Math.round(size * 0.42),
      }}
    >
      {initials || '·'}
    </div>
  )
}

function hashColor(s: string): string {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  const palette = ['#8AB89F', '#E8A87C', '#7BA7C4', '#D4A24C', '#9B7BB8', '#6FA8A0', '#D4919B', '#D9AC5C']
  return palette[Math.abs(h) % palette.length]
}
